import { Internship } from './../../models/internship';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AddInternshipDialogComponent } from '../../modal/add-internship-dialog/add-internship-dialog.component';
import { AlertService } from '../../service/alert.service';
import { CompanyService } from '../../service/company.service';
import { CreateAvailableInternshipDialogComponent } from '../../modal/create-available-internship-dialog/create-available-internship-dialog.component';
import { CreateAvailableInternshipAvailability, InternshipsService } from '../../service/internships.service';
import { AvailableInternship } from '../../models/availableInternship.models';
import { ViewAvailableInternshipDialogComponent } from '../../modal/view-available-internship-dialog/view-available-internship-dialog.component';
import { ConfirmationnDialogComponent } from '../../modal/confirmation-dialog/confirmation-dialog.component';
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { AlertMessageComponent } from "../../shared/alert-message/alert-message.component";
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-available-internships',
  standalone: true,
  templateUrl: './available-internships.component.html',
  styleUrl: './available-internships.component.css',
  imports: [MatIcon, MatProgressSpinner, AlertMessageComponent, MatTooltipModule, CommonModule, ReactiveFormsModule, FormsModule, TranslateModule]
})
export class AvailableInternshipsComponent implements OnInit{

  
  constructor(public dialog: MatDialog, private internshipsService: InternshipsService,
              private route: Router, private alertService: AlertService, private translate: TranslateService){}

  allData: AvailableInternship[] = [];
  isLoading = false;
  searchTerm: string = '';
  visibilityFilter: string = '';
  isProfileCompleted = false;
  isQuestionnaireFilled = false;
  isCreateAvailable = false;
  createTooltipReasonKey = '';
  createTooltipReasonParams: Record<string, string> = {};


  filteredData: AvailableInternship[] = [];


  ngOnInit(): void {
    this.isLoading = true;
    this.loadInternships();

    this.internshipsService.canCreateAvailableInternship().subscribe(
      (   res: CreateAvailableInternshipAvailability) => {
        this.isCreateAvailable = res.canCreate;
        this.createTooltipReasonKey = res.reason || '';
        this.createTooltipReasonParams = res.reasonParams ?? {};
      },
      (    err: any) => {
        this.isCreateAvailable = false;
        this.createTooltipReasonKey = 'available-internships.create-tooltip-error';
        this.createTooltipReasonParams = {};
      }
    );
  }

  openCreateAvailableInternshipDialog(): void {
    if (!this.isCreateAvailable) return; 

    const dialogRef = this.dialog.open(CreateAvailableInternshipDialogComponent, {
      panelClass:'custom-dialog-create-available-internship',
      disableClose: true 
    });

    dialogRef.afterClosed().subscribe(() => {
      /* console.log('La dialog è stata chiusa'); */
    });
  }

  loadInternships(): void {
    this.internshipsService.getAllAvailableInternships().subscribe({
      next: (data) => {
        this.allData = data;
        this.filteredData = [...this.allData];
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Errore nel caricamento dei tirocini:', err);
        this.isLoading = false;
      }
    });
  }

  toggleVisibility(internship: any): void {
    const newVisibility = !internship.visibility;

    const message = newVisibility
      ? this.translate.instant('available-internships.confirm-enable')
      : this.translate.instant('available-internships.confirm-disable');

    const dialogRef = this.dialog.open(ConfirmationnDialogComponent, {
      width: '400px',
      data: { message }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.internshipsService.updateVisibility(internship.id, newVisibility)
          .subscribe({
            next: () => {
              internship.visibility = newVisibility; 
              this.alertService.successKey('available-internships.visibility-update-success');
            },
            error: err => {
              console.error('Errore aggiornando la visibilità', err);
              this.alertService.errorKey('available-internships.visibility-update-error');
            }
          });
      }
    }); 
  }

  

  viewAvailableInternshipDialog(availableInternship:AvailableInternship): void {
    const dialogRef = this.dialog.open(ViewAvailableInternshipDialogComponent, {
      panelClass:'custom-dialog-available-internship',
      data: availableInternship,
      disableClose: true 
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('La dialog è stata chiusa');
    });
  }

  deleteAvailableInternshipDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmationnDialogComponent, {
      width: '400px',
      data: { message: this.translate.instant('available-internships.confirm-delete') }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if (!id) return;
        this.internshipsService.deleteAvailableInternship(id).subscribe({
          next: (msg: string) => {
            // Aggiorna la lista visivamente rimuovendo l'internship eliminato
            this.filteredData = this.filteredData.filter(internship => internship.id !== id);
            // Se hai anche un array originale this.allData, aggiornarlo anch'esso
            this.allData = this.allData.filter(internship => internship.id !== id);
            this.alertService.success(msg);
          },
          error: (err) => {
            console.log(err.error)
            this.alertService.error(err.error);
          }
        });
      }
    });
  }

  applyFilters() {
    const globalFilterLower = (this.searchTerm || '').trim().toLowerCase();
    const visibilityValue = this.visibilityFilter;

    this.filteredData = this.allData.filter(internship => {
      const matchesGlobal =
        !globalFilterLower ||
        (internship.title || '').toLowerCase().includes(globalFilterLower) ||
        (internship.position || '').toLowerCase().includes(globalFilterLower) ||
        (internship.department || '').toLowerCase().includes(globalFilterLower);

      const matchesVisibility =
        !visibilityValue || String(internship.visibility) === visibilityValue;

      return matchesGlobal && matchesVisibility;
    });
  }

  clearFilters() {
    this.searchTerm = '';
    this.visibilityFilter = '';
    this.applyFilters();
  }
}

